import { Tabs } from '@mantine/core';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { ExportButton } from '../export/ExportButton';
import { GroupedAttendanceTable } from './components/GroupedAttendanceTable';
import { IndividualAttendanceTable } from './components/IndividualAttendanceTable';
import type { AttendanceDto, TotalAttendanceDto } from './types/AttendanceDto';

export function Attendance() {
	const { organisation } = useParams();
	const filter = useFilter();

	useEffect(() => {
		document.body.style.backgroundColor = 'white';
	}, []);

	// The following code must be moved into this component to ensure that the individual rows can call a reset if updated
	const pagination = usePagination();

	const attendanceGroupCountQuery = queryWithFilter<number>(
		`${organisation}/attendance/grouped/count`,
		filter.value,
	);

	const attendanceGroupQuery = queryWithFilterAndPages<TotalAttendanceDto[]>(
		`${organisation}/attendance/grouped/all`,
		filter.value,
		pagination.value,
	);

	const individualAttendanceCountQuery = queryWithFilter<number>(
		`${organisation}/attendance/individual/count`,
		filter.value,
	);

	const individualAttendanceQuery = queryWithFilterAndPages<AttendanceDto[]>(
		`${organisation}/attendance/individual/all`,
		filter.value,
		pagination.value,
	);

	const refreshTables = () => {
		attendanceGroupCountQuery.remove();
		attendanceGroupQuery.remove();

		attendanceGroupCountQuery.refetch();
		attendanceGroupQuery.refetch();

		individualAttendanceCountQuery.remove();
		individualAttendanceQuery.remove();

		individualAttendanceCountQuery.refetch();
		individualAttendanceQuery.refetch();
	};

	return (
		<>
			<PageHeader
				title={'Time and Attendance'}
				filter={filter}
				rightContent={
					<ExportButton apiPath={`${organisation}/attendance/export`} />
				}
			/>
			<Tabs color="medepos.1" defaultValue="grouped" w={'100%'}>
				<Tabs.List color={'medepos.0'}>
					<Tabs.Tab value="grouped">Grouped</Tabs.Tab>
					<Tabs.Tab value="Individual">Individual</Tabs.Tab>
				</Tabs.List>

				<Tabs.Panel value="grouped" pt={25}>
					<GroupedAttendanceTable
						filter={filter.value}
						attendanceCountQuery={attendanceGroupCountQuery}
						attendanceQuery={attendanceGroupQuery}
						pagination={pagination}
						refreshTables={refreshTables}
					/>
				</Tabs.Panel>

				<Tabs.Panel value="Individual" pt={25}>
					<IndividualAttendanceTable
						filter={filter.value}
						refreshTables={refreshTables}
						attendanceCountQuery={individualAttendanceCountQuery}
						attendanceQuery={individualAttendanceQuery}
					/>
				</Tabs.Panel>
			</Tabs>
		</>
	);
}
